export enum NotificationTypeEnum {
    VideoCallInvite = "videoCallInvite",
    VideoCallInviteAccept = "videoCallInviteAccept",
    VideoCallInviteReject = "videoCallInviteReject",
    VideoCallCancelled = "videoCallCancelled",
    FamilyBroadcast = "familyBroadcast",
    FamilyNotification = "familyNotification",
    ServiceRequestStatusChanged = "serviceRequestStatusChanged",
    FamilyHasApprovedServiceRequest = "familyHasApprovedServiceRequest",
    FamilyHasRejectedServiceRequest = "familyHasRejectedServiceRequest",
    FamilyHasPurchasedServiceRequest = "familyHasPurchasedServiceRequest",
    Message = "message",
    HomeMessage = "homeMessage",
    ServiceApproval = "serviceApproval",
    ServiceRequest = "serviceRequest",
    VisitCreated = "visitCreated",
    VisitCancel = "visitCancel",
    Call = "call",
    EventAttendance = "eventAttendance",
    ConciergeEventScheduled = "conciergeEventScheduled",
    FriendRequest = 'friendRequest',
    MailingList = "mailingList",
    ServiceRequestCreated = "serviceRequestCreated",
    ServiceRequestCompleted = "serviceRequestCompleted",
    UnattendedEventEnded = "unattendedEventEnded",
    MaintenanceRequestCreated = "maintenanceRequestCreated",
    MaintenanceRequestCompletionDeadline = "maintenanceRequestCompletionDeadline",
    MaintenanceRequestComment = "maintenanceRequestComment",
    DeviceAssigned = "deviceAssigned",
    DeviceUnassigned = "deviceUnassigned",
    BookingsAndOrdersComment = 'bookingsAndOrdersComment',
    StaffAppResidentUpcomingCall = 'staffAppResidentUpcomingCall',
    StaffAppResidentUpcomingEvent = 'staffAppResidentUpcomingEvent',
    StaffAppResidentIncomingRequest = 'staffAppResidentIncomingRequest',
    StaffAppResidentTodaysBirthday = 'staffAppResidentTodaysBirthday',
    StaffAppResidentSuggestedUserStory = 'staffAppResidentSuggestedUserStory',
    TransferResident = 'transferResident',
    ReScheduledCall = 'reScheduledCall',
    ScheduledCall = 'scheduledCall',
    RealtimeCall = 'realtimeCall',

    FeedbackRequestCreated = 'feedbackRequestCreated',
    FeedbackRequestClosed = 'feedbackRequestClosed',
    FeedbackRequestPending = 'feedbackRequestPending',
    FeedbackRequestNewMessage = 'feedbackRequestNewMessage',
    FeedbackRequestStale = 'FeedbackRequestStale'
  }